import { FC } from 'react'
import Modal from '@common/Modal'
import { IcoRemove } from '@/utils/icons'
import Button from '@UI/New/Button'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'

type UpdateIntegrationsOnPhoneChangeModalProps = {
  open: boolean
  loading?: boolean
  onUpdateIntegrations: () => void
  onKeepIntegrations: () => void
  onDismiss: () => void
}

const UpdateIntegrationsOnPhoneChangeModal: FC<
  UpdateIntegrationsOnPhoneChangeModalProps
> = ({
  open,
  loading = false,
  onUpdateIntegrations,
  onKeepIntegrations,
  onDismiss,
}) => (
  <Modal
    active={open}
    className={mclasses.confirmModalWrapper as any}
    setActive={() => {
      if (loading) return
      onDismiss()
    }}
  >
    <div className={mclasses.modalContainer}>
      <div className={mclasses.modalHeader}>
        <div className={mclasses.modalTitleContainer}>
          <span className={mclasses.modalHeaderTitle}>
            Обновить интеграции по номеру?
          </span>
        </div>
        <button
          type="button"
          className={mclasses.closeIcon}
          onClick={onDismiss}
          aria-label="Закрыть"
          disabled={loading}
        >
          <IcoRemove />
        </button>
      </div>
      <div className={mclasses.formWrapper}>
        <p>
          Вы изменили телефон лида. Обновить связанные поля интеграций
          (WhatsApp и другие совместимые каналы) по новому номеру?
        </p>
        <p>
          Поля VK, Telegram и MAX не изменятся. Если выбрать «Только телефон»,
          интеграционные поля останутся как есть.
        </p>
      </div>
      <div className={mclasses.actions}>
        <Button
          color="gray"
          onClick={onKeepIntegrations}
          disabled={loading}
        >
          Только телефон
        </Button>
        <Button
          color="primary"
          onClick={onUpdateIntegrations}
          isLoading={loading}
          disabled={loading}
        >
          Обновить интеграции
        </Button>
      </div>
    </div>
  </Modal>
)

export default UpdateIntegrationsOnPhoneChangeModal
